import React from "react";
import {
  Button,
  Card,
  CardHeader,
  CardBody,
  CardTitle,
  Row,
  Col,
  Input,
  FormGroup,
  Label,
} from "reactstrap";

import {
  createYearlyIndicatorsRequest,
  getYearlyIndicatorRequest,
  updateYearlyIndicatorRequest,
} from "../../api/yearlyIndicators";
import CurrencyInput from 'components/CurrencyInput/CurrencyInput';

class YearlyIndicatorForm extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      yearlyIndicator: null,
      error: null,
      saving: false,
      validCommission: null,
    };
  }

  async componentDidMount() {
    const params = new URLSearchParams(this.props.location.search);
    const id = params.get("id");

    if (id) {
      try {
        const yearlyIndicator = await getYearlyIndicatorRequest(id);
        this.setState({ yearlyIndicator });
      } catch (err) {
        this.setState({
          error: err.message || "There was an error fetching yearly indicator",
        });
      }
    } else {
      this.setState({
        yearlyIndicator: {
          year: "",
        },
      });
    }
  }
  goTo = (path) => this.props.history.push(path);

  save = async () => {
    this.setState({
      saving: true,
    });

    const { yearlyIndicator } = this.state;
    const { _id } = yearlyIndicator;

    try {
      if (_id) {
        await updateYearlyIndicatorRequest(yearlyIndicator);
      } else {
        await createYearlyIndicatorsRequest(yearlyIndicator);
      }
      this.setState({
        saving: false,
      });
      this.goTo("/yearly-indicators");
    } catch (err) {
      console.log(err, "error");
      this.setState({
        error: err.message || "There was an error saving yearly indicator",
        saving: false,
      });
    }
  };

  onChangeField = (e) => {
    const { target } = e;
    let { name, value } = target;
    if (name === "commission_percentage") {
      value = Number(value);
    }
    this.setState((prevState) => ({
      yearlyIndicator: {
        ...prevState.yearlyIndicator,
        [name]: value,
      },
    }));
  };

  createYearlyIndicator = async () => {
    this.setState({
      saving: true,
    });

    const { yearlyIndicator } = this.state;

    try {
      if (yearlyIndicator._id) {
        await updateYearlyIndicatorRequest(yearlyIndicator);
      } else {
        await createYearlyIndicatorsRequest(yearlyIndicator);
        this.setState({
          saving: false,
        });
        this.goTo("/yearly-indicators");
      }
    } catch (err) {
      console.log(err, "error");
      this.setState({
        error: err.message || "There was an error saving yearly indicator",
        saving: false,
      });
    }
  };

  onChangeLandCost = (value) => {
    const { yearlyIndicator } = this.state;
    
    this.setState({
      yearlyIndicator: {
        ...yearlyIndicator,
        landCostSqm: value
      },
    });
  }

  onChangeLandDevCost = (value) => {
    const { yearlyIndicator } = this.state;
    
    this.setState({
      yearlyIndicator: {
        ...yearlyIndicator,
        landDevCostSqm: value
      },
    });
  }

  onChangeConstructionCost = (name, value) => {
    const { yearlyIndicator } = this.state;
    this.setState({
      yearlyIndicator: {
        ...yearlyIndicator,
        constructionCostSqm: {
          ...yearlyIndicator.constructionCostSqm,
          [name]: value,
        },
      },
    });
  };

  render() {
    const { yearlyIndicator = {}, error = null, saving } = this.state;

    const {
      _id,
      year,
      landCostSqm,
      landDevCostSqm,
      constructionCostSqm = {},
    } = yearlyIndicator || {};

    const { narra, banyan, redwood, bamboo, oakwood } =
      constructionCostSqm || {};

    return (
      <>
        <div className="content">
          <Row>
            <Col md="12">
              <Card>
                <CardHeader>
                  <CardTitle className="d-inline-block" tag="h4">
                    Yearly Indicator
                  </CardTitle>
                  <Button
                    className="float-right"
                    color="default"
                    onClick={() => this.goTo("/yearly-indicators")}
                  >
                    Back
                  </Button>
                </CardHeader>
                <CardBody>
                  <Row>
                    <Col sm={12}>
                      <FormGroup>
                        <Label>
                          Year <span className="required-start">*</span>
                        </Label>
                        <Input
                          type="text"
                          name="year"
                          value={year || ""}
                          onChange={this.onChangeField}
                        />
                      </FormGroup>
                    </Col>
                    <Col sm={12}>
                      <FormGroup>
                        <Label>
                          Land Cost (Sq m.){" "}
                          <span className="required-start">*</span>
                        </Label>
                        <CurrencyInput
                          name="landCostSqm"
                          placeholder=""
                          price={landCostSqm}
                          onChange={(value) => this.onChangeLandCost(value)}
                        />
                      </FormGroup>
                    </Col>
                    <Col sm={12}>
                      <FormGroup>
                        <Label>
                          Land Development Cost (Sq m.){" "}
                          <span className="required-start">*</span>
                        </Label>
                        <CurrencyInput
                          name="landDevCostSqm"
                          placeholder=""
                          price={landDevCostSqm}
                          onChange={(value) => this.onChangeLandDevCost(value)}
                        />
                      </FormGroup>
                    </Col>
                  </Row>
                  <Row>
                    <Col sm={12}>
                      <h5>Construction Cost (Sq m.)</h5>
                    </Col>
                    <Col sm={12} md={6}>
                      <FormGroup>
                        <Label>
                          Narra <span className="required-start">*</span>
                        </Label>
                        <CurrencyInput
                          name="narra"
                          placeholder=""
                          price={narra}
                          onChange={(value) => this.onChangeConstructionCost("narra", value)}
                        />
                      </FormGroup>
                    </Col>
                    <Col sm={12} md={6}>
                      <FormGroup>
                        <Label>
                          Banyan <span className="required-start">*</span>
                        </Label>
                        <CurrencyInput
                          name="banyan"
                          placeholder=""
                          price={banyan}
                          onChange={(value) => this.onChangeConstructionCost("banyan", value)}
                        />
                      </FormGroup>
                    </Col>
                    <Col sm={12} md={6}>
                      <FormGroup>
                        <Label>
                          Redwood <span className="required-start">*</span>
                        </Label>
                        <CurrencyInput
                          name="redwood"
                          placeholder=""
                          price={redwood}
                          onChange={(value) => this.onChangeConstructionCost("redwood", value)}
                        />
                      </FormGroup>
                    </Col>
                    <Col sm={12} md={6}>
                      <FormGroup>
                        <Label>
                          Bamboo <span className="required-start">*</span>
                        </Label>
                        <CurrencyInput
                          name="bamboo"
                          placeholder=""
                          price={bamboo}
                          onChange={(value) => this.onChangeConstructionCost("bamboo", value)}
                        />
                      </FormGroup>
                    </Col>
                    <Col sm={12} md={6}>
                      <FormGroup>
                        <Label>
                          Oakwood <span className="required-start">*</span>
                        </Label>
                        <CurrencyInput
                          name="oakwood"
                          placeholder=""
                          price={oakwood}
                          onChange={(value) => this.onChangeConstructionCost("oakwood", value)}
                        />
                      </FormGroup>
                    </Col>
                  </Row>
                  {error ? (
                    <div className="alert alert-danger mt-3">
                      <span>{error}</span>
                    </div>
                  ) : null}
                  <Button
                    color="primary"
                    block={false}
                    className="mb-4"
                    onClick={this.save}
                  >
                    {saving
                      ? "Saving..."
                      : _id
                      ? "Save Changes"
                      : "Save Indicator"}
                  </Button>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </div>
      </>
    );
  }
}

export default YearlyIndicatorForm;
